module.exports = __webpack_public_path__ + "img/wifi_signal_3_selected.1c5f6abc.svg";